import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { RequestsServices } from '../../services/requests.service';
import { GTMService } from '../../services/gtm.service';

@Component({
  selector: 'ng-core-file-upload',
  styleUrls: ['./file-upload.component.scss'],
  templateUrl: './file-upload.component.html',
  providers: [UserService, RequestsServices, GTMService]
})
export class FileUploadComponent {

  @Input() title = 'Upload de arquivo';
  @Input() subtitle: string;
  @Input() multiple = false;
  @Input() disabled = false;
  @Input() sendInvite = true;

  @ViewChild('fileInput') fileInput: ElementRef;

  files: any[] = [];
  loading = false;
  canHandleClick = true;
  uploadCompleted = false;
  error: { title: string, message: string } = null;
  acceptedFileTypes = ['xls', 'xlsx'];

  acceptedMimeTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/excel',
    'application/msexcel',
    'application/x-msexcel',
    'application/x-ms-excel',
    'application/x-excel',
    'application/x-dos_ms_excel',
    'application/xls',
    'application/x-xls'
  ];

  constructor(
    private userService: UserService,
    private request: RequestsServices,
    private gtmService: GTMService,
  ) {}

  openFile() {
    if (this.canHandleClick) {
      this.fileInput.nativeElement.click();
    }
  }

  uploadFile(event) {
    for (const element of event) {
      this.checkFileType(element);

      if (this.multiple) {
        this.files.push(element);
      } else {
        this.files[0] = element;
      }
    }

    this.canHandleClick = false;
  }

  checkFileType(file) {
    const splitName = file.name.split('.');
    const type = splitName[splitName.length - 1];
    const wrongType = file.type ? !this.acceptedMimeTypes.includes(file.type) : !this.acceptedFileTypes.includes(type);

    if (wrongType) {
      this.error = {
        title: 'Formato inválido!',
        message: 'Formato de arquivo não suportado. Seu arquivo deve possuir formato .xls ou .xlsx.'
      };
    }

  }

  deleteFile(index) {
    this.files.splice(index, 1);

    // TODO: Implement a way to edit the "nativeElement.files" and remove only a selected file.
    this.fileInput.nativeElement.value = '';

    setTimeout(() => this.canHandleClick = true, 200);
  }

  humanFileSize(FileSize: number) {
    const i = Math.floor(Math.log(FileSize) / Math.log(1024));
    const size = (FileSize / Math.pow(1024, i)).toFixed(2);
    return `${size} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
  }

  sendFile(invite = false) {
    this.loading = true;
    const company = this.userService.getLoggedAccount();
    const file: File = this.files[0];
    const fileExtension = this.getFileExtension(file.name);
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const base64Data = e.target.result.split(',')[1];
      const payload = { file: base64Data, fileExtension, fileName: file.name };
      const customPath = `/bulk_import/upload?companyId=${company.id}&invite=${invite}`;
      this.request.post('customers', payload, '', customPath)
        .then(() => {
          this.uploadCompleted = true;
        })
        .catch((error) => {
          this.gtmService.error('customers-import-upload', error, {customPath});
          this.handleError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    };

    reader.readAsDataURL(file);
  }

  getFileExtension(fileName: string): string {
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex !== -1 ? fileName.substring(dotIndex + 1).toLowerCase() : '';
  }

  resetUpload() {
    this.files = [];
    this.fileInput.nativeElement.value = '';
    this.uploadCompleted = false;
    this.canHandleClick = true;
    this.error = null;
  }

  handleError({ error }) {
    switch (error && error.statusCode) {

      case 500: {
        if (error.statusMessage === 'FILE_INVALID_EXTENSION_ERROR') {
          this.error = {
            title: 'Formato inválido!',
            message: 'Formato de arquivo não suportado. Seu arquivo deve possuir formato .xls ou .xlsx.'
          };
        } else {
          this.error = {
            title: 'Ocorreu um erro!',
            message: 'Não foi possível enviar o seu arquivo. Tente novamente ou entre em contato com o suporte.'
          };
        }
        break;
      }

      case 400: {
        this.error = {
          title: 'Formatação incorreta!',
          message: 'Possíveis Erros: <br> 1. Cabeçalho fora do padrão. <br> 2. Campos vazios.'
        };
        break;
      }

      default: {
        this.error = {
          title: 'Ocorreu um erro!',
          message: 'Não foi possível enviar o seu arquvio. Tente novamente ou entre em contato com o suporte.'
        };
      }
    }
  }
}
